export default __webpack_public_path__ + "028786bac2a8bd62995cc92ea912ccf2.png";